import {Cureus} from '../Cureus';

Cureus.Media = {};
  
//= require_tree ./Media
  